import React from 'react';
import { showError } from '../utils/methods';
// import { Error } from '../models/error';

interface State {
  status: string;
  error: string;
}

interface Action {
  type: string;
  error?: { type: string; message: string };
}

const initialState: State = {
  status: 'initial load',
  // @ts-ignore
  error: null,
};

// DISPLAYS a progress cursor when data is processing
function setCursor(status: string) {
  // eslint-disable-next-line no-multi-assign
  const cursorStatus = document.body.style.cursor = status;
  return cursorStatus;
}

// SETS loading or processing states based on the dispatch
function processingReducer(state: State, action: Action) {
  switch (action.type) {
    case 'ERROR': // for any errored state
      setCursor('default');

      return {
        ...state,
        status: 'errored',
        error: action.error,
      };
    case 'STARTED': // for process starting
      setCursor('progress');

      return {
        ...state,
        status: 'pending',
      };
    case 'SUCCESS': // for process completion
      setCursor('default');

      return {
        ...state,
        status: 'complete',
      };
    case 'IDLE': // for component loading
      return {
        ...state,
        status: 'initial load',
      };
    case 'LOADED': // for component loading
      return {
        ...state,
        status: 'resolved',
      };
    default:
      throw new Error(`Unhandled processing type: ${action.type}`);
  }
}

export default function useProcess() {
  // @ts-ignore
  const [state, dispatch] = React.useReducer(processingReducer, initialState);

  if (state.status === 'errored') {
    // @ts-ignore
    showError(state.error as Error);
    state.status = 'resolved';
  }

  return { ...state, dispatch };
}
